(function () {
  function updateSkuBlock(block) {
    var mapEl = block.querySelector('script[data-sku-map]');
    var labelEl = block.querySelector('.product-sku__label');
    var valueEl = block.querySelector('.product-sku__value');
    if (!mapEl) return;

    var skuMap;
    try {
      skuMap = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }

    var form = block.closest('form');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    if (!idInput) return;

    var sku = skuMap[idInput.value];

    if (sku) {
      if (!labelEl) {
        labelEl = document.createElement('span');
        labelEl.className = 'product-sku__label';
        labelEl.textContent = block.dataset.label || 'SKU:';
        block.insertBefore(labelEl, mapEl);
      }
      if (!valueEl) {
        valueEl = document.createElement('span');
        valueEl.className = 'product-sku__value';
        block.insertBefore(valueEl, mapEl);
      }
      valueEl.textContent = sku;
    } else {
      if (labelEl) labelEl.remove();
      if (valueEl) valueEl.remove();
    }
  }

  function initSkuBlocks() {
    document.querySelectorAll('product-sku-block').forEach(function (block) {
      var form = block.closest('form');
      if (!form) return;

      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      // Native change events (works for <select> variant pickers)
      form.addEventListener('change', function () {
        updateSkuBlock(block);
      });

      // Catches programmatic value updates (swatch/button pickers)
      // that don't fire native change events.
      var observer = new MutationObserver(function () {
        updateSkuBlock(block);
      });
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkuBlocks);
  } else {
    initSkuBlocks();
  }
})();
